import useDashboardContext from 'contexts/dashboard.context';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const CokitchenDetailsIndex = () => {
  const navigate = useNavigate();
  const { routePrefix } = useDashboardContext();

  useEffect(() => {
    navigate(`${routePrefix}/${ROUTE_KEYS.COKITCHEN_DETAILS}/${ROUTE_KEYS.BRAND_DETAILS_PAGE}`, {
      replace: true
    });
  }, []);

  return <div />;
};

export default CokitchenDetailsIndex;
